module.exports = __webpack_public_path__ + "static/media/social-odnoklassniki.bd77e74c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-odnoklassniki.svg
// module id = 351
// module chunks = 0